export default __webpack_public_path__ + "8d8a93b9501def0503324168dbdb281b.png";